
      import Service from './service.vue'
      import type { App, Plugin } from 'vue'

      export const ServicePlugin: Plugin = {
        install(app: App) {
          app.component('Service', Service)
        },
      }
      export { Service }
      